import { useAuth } from "app/hooks";
import useCampaignParams from "app/hooks/useCampaignParams";
import HeaderConnect from "app/widgets/crypto-header/header-connect";
import { FC, useEffect, useMemo, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  usePostReferralMutation,
  useTrackCampaignDataMutation,
} from "store/api/new.api";
import { useAccount } from "wagmi";
import Modal from "../modal/Modal";

import styles from "./CampaignTracker.module.scss";

const CampaignTracker: FC = () => {
  const isAuth = useAuth();
  const { address } = useAccount();
  const [campaignData, showModal, closeModal] = useCampaignParams();
  const [trackCampaignData] = useTrackCampaignDataMutation();
  const [postReferral] = usePostReferralMutation();
  const { idoId } = useParams<{ idoId: string }>();

  useEffect(() => {
    console.log("isAuth:", isAuth);
    console.log("address:", address);
    console.log("idoId:", idoId);
  }, [isAuth, address, idoId]);

  useEffect(() => {
    const campaignId =
      campaignData.campaignId ||
      campaignData.utm ||
      campaignData.campaigId ||
      localStorage.getItem("campaignId") ||
      localStorage.getItem("campaigId") ||
      localStorage.getItem("utm") ||
      "";
    if (isAuth && address) {
      if (campaignId) {
        trackCampaignData({ address, campaignId })
          .unwrap()
          .then(() => console.log("Campaign data sent successfully"))
          .catch((err) => console.error("Error sending campaign data:", err));
      } else {
        console.log("No campaign data available for tracking.");
      }
    } else {
      if (campaignId) localStorage.setItem("campaignId", campaignId);
    }
  }, [isAuth, address, campaignData, trackCampaignData]);

  const location = useLocation();
  const currentInvite = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("invite") || "";
  }, [location.search]);

  const lastSentInviteRef = useRef<string>("");

  useEffect(() => {
    if (isAuth && address && currentInvite && idoId) {
      if (currentInvite !== lastSentInviteRef.current) {
        postReferral({ refId: currentInvite, idoId })
          .unwrap()
          .then((response) => {
            if (response.status === "success") {
              localStorage.setItem("invite", currentInvite);
            }
            console.log(
              "Invite data sent successfully with refId:",
              currentInvite
            );
            lastSentInviteRef.current = currentInvite;
          })
          .catch((err) => console.error("Error sending invite data:", err));
      } else {
        console.log("Invite data already sent with refId:", currentInvite);
      }
    } else if (currentInvite) {
      localStorage.setItem("invite", currentInvite);
    }
  }, [isAuth, address, currentInvite, idoId, postReferral]);

  return (
    <>
      {showModal && (
        <Modal onClose={() => closeModal()}>
          <h2>🪙 Exclusive TDS Pre-Sale Offer — Limited Time Only!</h2>
          <p>
            Get at <span className={styles.line}>🚫 $15M</span>{" "}
            <b className={styles.bold}>✅ $10M</b> FDV on{" "}
            <b className={styles.bold}>AlphaMind</b>
          </p>
          <p>
            <b className={styles.bold}>🎁 +15% $TDS airdrop</b> for all early
            buyers (auto-whitelisted)
          </p>
          <p>
            <b className={styles.bold}>🚀 TGE this May</b> — MEXC listing
            confirmed, big unlock at launch
          </p>
          <div className={styles.connectBtn}>
            {!isAuth && <HeaderConnect title="Connect Wallet" />}
          </div>
        </Modal>
      )}
    </>
  );
};

export default CampaignTracker;
